





























































import { Component, Vue } from 'vue-property-decorator'
import { DappClient } from 'dapp-client'
import { vxm } from '@/store'

const endpoint = 'https://eos.eosn.io'
const client = new DappClient(endpoint, {})

@Component
export default class UserTokens extends Vue {
  private loading = false
  private balance: any = ''
  private contract: string = ''
  private scope: string = ''
  private table: string = 'accounts'
  private symbol: string = ''

  // methods
  getVtokenBalance() {
    this.loading = true
    this.balance = this.$t('view.vRamTokens.loading')
    client
      .dsp_ipfs_get_table_row<{ balance: string }>(
        this.contract,
        this.scope,
        this.table,
        this.symbol
      )
      .then((resp: any) => {
        this.balance = resp.row.balance
        this.loading = false
      })
      .catch((error: any) => {
        this.balance = this.$t('view.vRamTokens.noTokensFound')
        this.loading = false
      })
  }
  // Lifecycle hooks
  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
